import React from 'react';

// Latest Habbstagram posts for a profile. Data comes from our own API
// (/api/habbstagram/:habboName/posts), which holds the partner key - the
// profile only renders this box when that returns posts.
const HabbstagramBox = ({ data }) => {
    const { profile, posts } = data;
    return (
        <div className="p-3">
            <div className="grid grid-cols-3 gap-2">
                {posts.map((post) => (
                    <a
                        key={post.id}
                        href={post.postUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="block bg-black/5 overflow-hidden hover:brightness-90 transition"
                        title={post.caption || 'View on Habbstagram'}
                    >
                        <img
                            src={post.imageUrl}
                            alt={post.caption || 'Habbstagram post'}
                            loading="lazy"
                            className="w-full aspect-square object-cover"
                        />
                    </a>
                ))}
            </div>
            <div className="flex justify-end mt-2">
                <a
                    href={profile.habbstagramUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-['Jersey_10'] uppercase text-[15px] tracking-[1px] text-maroon hover:underline"
                >
                    View full Habbstagram &rarr;
                </a>
            </div>
        </div>
    );
};

export default HabbstagramBox;
